import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-complete-order-dialog',
  templateUrl: './complete-order-dialog.html',
  styleUrls: ['./complete-order-dialog.scss'],
})
export class CompleteOrderDialogComponent implements OnInit {
  /* @Input()
  cart: any; */

  /* @Input()
  cartId: any; */

  /* @Input()
  userType: any; */

  earliestShipDate

  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.earliestShipDate = data.earliestShipDate
    })
  }

  closeModal(reason?: any): void {
    if (reason == 'success-order') {
      const dialogResponse: DialogResponse = {
        data: this.earliestShipDate,
        type: VS_LAUNCH_CALLER.COMPLETE_ORDER,
        reason: reason,
      }
      this.launchDialogService.closeDialog(dialogResponse)
    } else {
      const dialogResponse: DialogResponse = {
        type: VS_LAUNCH_CALLER.COMPLETE_ORDER,
        reason: reason,
      }
      this.launchDialogService.closeDialog(dialogResponse)
    }
  }
}
